// Utility to flush redux-persist store
import {persistor, dispatch} from '../../rootStore/store';

export function flushStore() {
  persistor.purge();
  dispatch({type: 'RESET'});
}
